export default __webpack_public_path__ + "static/media/clients-2-tone.af34cc24.png";